import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import DatePicker from "react-datepicker";
import Placeholder from "../../../assets/images/Placeholder.gif";
import "react-datepicker/dist/react-datepicker.css";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import { get, post } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import check from "../../../assets/images/check.svg";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { toast, Bounce } from "react-toastify";
const GymClearance = () => {
  document.title = "Gyms Clearance | Elevated - Admin Dashboard";
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gymId = searchParams.get("gymId");
  const [timeFilter, setTimeFilter] = useState("week");
  const [dropdownOpen, setDropdownOpen] = useState({ dateRange: false });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startSearchDate, setStartSearchDate] = useState();
  const [endSearchDate, setEndSearchDate] = useState();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [seletedGymId, setSeletedGymId] = useState("");
  const [selectedGym, setSelectedGym] = useState("");
  const [payoutError, setPayoutError] = useState("");
  const [payoutAmmount, setPayoutAmmount] = useState("");
  const [gymData, setGymData] = useState([]);
  const { currentUser } = useSelector((state) => state.auth);
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);

  const gymIds = async () => {
    try {
      let endpoint;
      if (currentUser.appRole === "admin") {
        endpoint = `${endpoints.gym}/admin?limit=50`;
      } else if (currentUser.appRole === "gymOwner") {
        endpoint = `${endpoints.gym}/admin?userId=${currentUser.id}&limit=50`;
      } else {
        console.error("User role is not admin or gymOwner.");
        return;
      }

      const resp = await get(endpoint);

      if (resp?.data?.success) {
        const gymList = resp.data.data || [];
        setGymData(gymList);

        if (gymList.length > 0) {
          setSelectedGym(gymList[0]?.name || "Unknown Gym");
          setSeletedGymId(gymList[0]?._id || null);
        } else {
        }
      } else {
        console.error(
          "Failed to fetch gyms:",
          resp?.data?.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error in fetching gyms:", error);
    }
  };

  useEffect(() => {
    if (
      currentUser.appRole == "gymOwner" ||
      currentUser.appRole == "gymStaff" ||
      currentUser.appRole == "admin"
    ) {
      gymIds();
    }
  }, []);
  const toggleDropdown = (key) => {
    setDropdownOpen((prevState) => ({ ...prevState, [key]: !prevState[key] }));
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await get(
        `${
          currentUser.appRole === "gymOwner"
            ? endpoints.wallets + "/" + currentUser.id
            : endpoints.wallets
        }?page=1&limit=50`
      );
      if (response && response.data) {
        setData(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [seletedGymId]);

  const GymPayout = async (gymId, amount) => {
    const resp = await post(endpoints.gymPayout, { gymId, amount });
    console.log("response: ", resp.data, resp, resp?.response?.data?.message);
    if (resp?.data?.success) {
      toast.success("Payment Transfer", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      fetchData();
      toggleModal();
    } else {
      toast.error(resp?.response?.data?.message, {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    }
  };

  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    }
    return num.toFixed(2);
  };
  let displayIndex = 0; // Initialize outside map

  return (
    <div className="">
      <Container fluid>
        <Card className="rounded-4">
          <CardBody>
            <div className="col-12 d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
              <div className="d-flex flex-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0 ">
                <span className=" font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0 d-md-block">
                  Gyms Clearance
                </span>
              </div>

              <div className="d-flex flex-column flex-sm-row flex-xs-column justify-content-end align-items-center gap-2 w-100 mt-2 mt-md-0">
                <div className="d-flex flex-xs-row gap-2"></div>
              </div>
            </div>

            <div className="table-responsive">
              <div
                className="hide-scrollbar table-responsive rounded-4"
                style={{
                  height: data?.length > 0 ? "500px" : "auto",
                }}
              >
                <Table
                  hover
                  className="table-borderless table-centered table-nowrap"
                >
                  <thead className="table-bordered">
                    <tr className="ff-sora font-size-14 fw-bold primary-black">
                      <th>No</th>
                      <th>Gym Name</th>
                      <th>Gym Email</th>
                      <th>Gym Location</th>
                      <th>Wallet Amount</th>
                      <th>Last Transaction</th>

                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={8} className="text-center">
                          <div className="d-flex justify-content-center align-items-center">
                            <div
                              className="spinner-border"
                              style={{
                                width: "3rem",
                                height: "3rem",
                                color: "#3BABA6",
                              }}
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : data.length === 0 ? (
                      <></>
                    ) : (
                      data.map((item, index) => {
                        if (item?.gymInfo?.name) {
                          displayIndex++; // Increment only for valid items

                          return (
                            <tr
                              key={item._id + displayIndex}
                              className="ff-sora fw-normal font-size-14 secondary-black"
                            >
                              <td>{displayIndex}</td>{" "}
                              {/* Now correctly starts from 1 */}
                              <td className="text-capitalize">
                                {item?.gymInfo?.name}
                              </td>
                              <td className="text-capitalize">
                                {item?.gymInfo?.email}
                              </td>
                              <td className="text-capitalize">
                                {item?.gymInfo?.location?.formatted_address}
                              </td>
                              <td>${item?.amount?.$numberDecimal || "0"}</td>
                              <td>{item?.lastTransactionType}</td>
                              <td>
                                <Button
                                  className="me-2 rounded-pill"
                                  onClick={(e) => {
                                    const today = new Date();
                                    const lastDay = new Date(
                                      today.getFullYear(),
                                      today.getMonth() + 1,
                                      0
                                    );
                                    const daysLeft =
                                      lastDay.getDate() - today.getDate();

                                    if (daysLeft <= 3) {
                                      toggleModal();
                                      setSelectedGym(item);
                                    } else {
                                      toast.error(
                                        "Looks like you're a bit early! Withdrawals are allowed only in the last three days of the month. Please check back later."
                                      );
                                    }
                                  }}
                                >
                                  Payout
                                </Button>
                              </td>
                            </tr>
                          );
                        }
                        return null;
                      })
                    )}
                  </tbody>
                </Table>
                {!loading && data.length === 0 && (
                  <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                    <img
                      src={Placeholder}
                      alt="No record placeholder"
                      className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                    />
                    <p className="mt-3 ff-sora font-size-16 fw-normal">
                      No Record Found!
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center table-bordered mt-3 p-2">
              <span className="fw-bold ff-sora secondary-black">
                Grand Total
              </span>
              <span className="fw-bold ff-sora secondary-black">
                ${formatNumber(parseFloat(totalAmount))}
              </span>
            </div>
          </CardBody>
        </Card>
      </Container>{" "}
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "60px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        className="modal-dialog-centered rounded-4"
      >
        <ModalHeader
          toggle={toggleModal}
          className="font-size-16 fw-medium ff-sora"
        >
          "{selectedGym?.gymInfo?.name}" Gym Payment Clearance
        </ModalHeader>
        <ModalBody className="font-size-14 fw-normal ff-sora">
          Please enter the payment amount you wish to clear. The gym currently
          has <strong>${selectedGym?.amount?.$numberDecimal}</strong> in its
          wallet.
          <Input
            type="number"
            name="clearanceAmount"
            placeholder="Enter the amount to clear"
            className="rounded-2 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
            onChange={(e) => {
              if (
                parseInt(e.target.value) >
                parseInt(selectedGym?.amount?.$numberDecimal)
              ) {
                setPayoutError(
                  "You cannot transfer larger amounts from the gym wallet."
                );
              } else {
                setPayoutError("");
                setPayoutAmmount(parseInt(e.target.value));
              }
            }}
          />
          {payoutError != "" && (
            <div className="text-danger">{payoutError}</div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            className=" rounded-pill"
            disabled={payoutError != "" ? true : false}
            onClick={(e) => {
              GymPayout(selectedGym?.gymId, payoutAmmount);
            }}
          >
            Pay
          </Button>
          <Button color="white" className="rounded-pill1" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default GymClearance;
